import React from "react";
import {Slide,Zoom} from "@mui/material";
import SuccessMsj from "./success"
import { TransitionProps } from "@mui/material/transitions";


export const TransZoom = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Zoom ref={ref} {...props}/>
});


export function SlideTransition(direction:"left" | "right" | "up" | "down" | undefined){
    return React.forwardRef(function Transition(
        props: TransitionProps & {
            children: React.ReactElement<any, any>;
        },
        ref: React.Ref<unknown>,
    ) {
        return <Slide direction={direction} ref={ref} {...props} />;
    });
}
export {SuccessMsj}


